module.exports = __webpack_public_path__ + "img/6.8ffd5aaa.png";